module.exports = __webpack_public_path__ + "static/media/infostretch.4de8d19c.svg";